import { getItsBpf } from './getSth.js';
import { find, go, selEq } from 'fxjs/es';
import { $hide, $qs, $setHTML, $show } from 'fxdom/es';
import { BPF_WANRINGS } from '../S/constant.js';
export async function showSpecialMessage(fcanvas) {
  const warning_type = getSpecialMessageType(fcanvas);
  if (!warning_type) return;
  const warning = find(selEq('type', warning_type))(BPF_WANRINGS);
  if (!warning) return;
  const el = $qs('#bpf_special_message');
  if (el) {
    go(el, $setHTML(warning.text()), $show);
  }
}
export function hideSpecialMessage() {
  const el = $qs('#bpf_special_message');
  if (el) $hide(el);
}

export function getSpecialMessageType(fcanvas) {
  const bpf = getItsBpf(fcanvas);
  return bpf.warning_type;
}
